import clsx from 'clsx';
import React from 'react';
import {
  FIREBOLT_INDEXING_DOC_LINK
} from '../constants/constants';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { HdDocLink, HdPane } from '../../../components';
import styles from './styles.module.scss';
import { TRACKER_FIREBOLT_INDEXING_DOC_LINK_CLICK } from '../tracking/schemaBuilderTracking';

export function FireboltColumnOrderAlertPane() {
  const { eventTrack } = useAnalyticsTracker();

  return (
    <HdPane
      variant='info-faded'
      className={clsx('w-100 mb-0', styles.fireboltMessage)}
      icon='info'
      iconClasses='text-info'
    >
      <span className='text-medium text-default'>
        Please arrange the columns as per the indexing order you want. For
        efficient queries, the column used the most for filtering should come
        first.
      </span>

      <HdDocLink
        section='firebolt_info_banner'
        className='ml-1'
        docLink={FIREBOLT_INDEXING_DOC_LINK}
        dataId='schema-builder-firebolt-indexing'
        onClick={() => {
          eventTrack({
            action: TRACKER_FIREBOLT_INDEXING_DOC_LINK_CLICK
          });
        }}
      />
    </HdPane>
  );
}
